import { createPublicClient, http, type PublicClient } from 'viem'

export const getEthProvider = (rpc: string): PublicClient => {
  return createPublicClient({
    transport: http(rpc),
  })
}
